module.exports = __webpack_public_path__ + "static/media/photo19.a968b62b.jpg";